function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { StateStatus } from '@guryou/redux';
const PrivateRoute = ({
  component: Component,
  saveRegion = false,
  ...rest
}) => {
  const el = new URLSearchParams(window.location.search).get('el');
  const pw = new URLSearchParams(window.location.search).get('pw');
  const auth = useSelector(state => state.auth);
  let url = '/login';
  if (el && pw) {
    url = `/login?el=${decodeURIComponent(el)}&pw=${decodeURIComponent(pw)}`;
  }

  // Only "is there a signed-in user" is judged here. Token expiry is NOT: `auth.data.exp` is the
  // ID-token payload captured once at login, while Amplify refreshes the real token silently on
  // every request, so comparing that snapshot with the clock ejected valid sessions (#1855). A dead
  // refresh token surfaces as Amplify's `tokenRefresh_failure` Hub event, which dispatches LOGOUT.
  if (!auth || !auth.data || auth.status < StateStatus.LOADED) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: url
    });
  }
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => /*#__PURE__*/React.createElement(Component, props)
  }));
};
export { PrivateRoute };